import { OfferRecord } from "./stuffAdapters";

export const offersData: OfferRecord[] = [
  {
    id: "offer-grecilooks-001",
    serialNo: 1,
    date: "2025-10-09",
    purchaseType: "INSTORE",
    sellerStoreName: "KBK STORES",
    sellerStoreId: "SNM1223455GH",
    category: "ELECTRONICS",
    status: "Active",
    productName:
      "GRECILOOKS Women's Tops – Crop Top, Loose Fit Oversized Shirts & Stylish Korean Tank Tops for Summer Wear",
    description:
      "A premium promotional offer available on selected in-store purchases from KBK Stores.",
    productImage:
      "https://images.unsplash.com/photo-1525507119028-ed4c629a60a3?auto=format&fit=crop&w=520&q=80",
    price: 10000,
    quantity: 1,
    discountPercent: 10,
    expiresIn: "1 Year",
  },
  {
    id: "offer-airpods-002",
    serialNo: 2,
    date: "2025-08-01",
    purchaseType: "INSTORE",
    sellerStoreName: "KBK STORES",
    sellerStoreId: "SNM1223455GH",
    category: "ELECTRONICS",
    status: "Active",
    productName:
      "Apple AirPods (3rd generation) with Lightning Charging Case",
    description:
      "Special in-store electronics offer with an eligible promotional discount for Salar customers.",
    productImage:
      "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?auto=format&fit=crop&w=520&q=80",
    price: 22000,
    quantity: 1,
    discountPercent: 10,
    expiresIn: "1 Year",
  },
  {
    id: "offer-voucher-003",
    serialNo: 3,
    date: "2025-07-18",
    purchaseType: "ONLINE",
    sellerStoreName: "SALAR RETAIL",
    sellerStoreId: "SLR987654",
    category: "SHOPPING",
    status: "Expired",
    productName: "Salar Shopping Voucher",
    description:
      "Promotional shopping voucher offer for eligible Salar purchases.",
    productImage:
      "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?auto=format&fit=crop&w=520&q=80",
    price: 1500,
    quantity: 1,
    discountPercent: 15,
    expiresIn: "6 Months",
  },
];
